module.exports = __webpack_public_path__ + "img/semin_wireless.cead0225.jpg";